import { useState } from '@wordpress/element';
import { Button, Flex, FlexBlock, FlexItem } from '@wordpress/components';
import { Icon, arrowRight,chevronLeftSmall } from '@wordpress/icons';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector, useDispatch } from 'react-redux';
import {addTrueFalse} from '../actions';
import UpgradeButton from './UpgradeButton';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  
export default function IframeTemplate(props) {
  const license = useSelector((state)=>state.licenseActivate);

  const dispatch = useDispatch();
  const myState = useSelector((state)=>state.trueFalse);

  const [ apiUrl, setApiUrl ] = useState(null);

const handelClose = ()=>{
     dispatch(addTrueFalse(true));
    var modalImg = document.getElementById("iframetmpl");
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
    document.body.style.overflow = "auto";
   // modalImg.src = '';
    urlReset();
    // window.location.reload(); 
}

const urlReset = ()=>{
  apiUrl && setApiUrl(null);
}

const nextInstall = ()=>{
  props.installHandel();
}

    return (<div className='iframe-footer header'>
        <Flex>
              <FlexItem>
              <div class="aisb-back">
              <div class="sb-column-close">
                <Button className="close" onClick={()=>handelClose()}>❮ Back</Button></div>
            </div>
              </FlexItem>
              <FlexBlock className='vb-continue-btn'>
              
              {(props.templateData.free_paid==='free' || license.status) &&  <div><span onClick={()=>nextInstall()} className={`aisb-install-btn ${license.status ===false && 'free-upgrade'}`}>Continue<b><Icon size ={22} icon={ arrowRight } /></b></span></div> }
              
              {props.templateData.free_paid==='paid' && <div className="header-text center" >
              </div>}
              
              </FlexBlock>
              <FlexItem>
              <div className="header-text">
             
              {(props.templateData.free_paid==='free' && license.status ===false) &&  <UpgradeButton/>}

              {props.templateData.free_paid==='paid' &&  <UpgradeButton/>}
            </div>
              </FlexItem>
            </Flex>
    </div>);
  }